var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "#BABDCC",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.901.304C8.765.116 8.51 0 8.233 0H.767C.49 0 .235.116.1.304s-.132.418.012.603l3.732 4.805c.14.179.388.288.657.288s.518-.11.657-.288L8.889.907c.144-.184.148-.415.012-.603z",
    transform: "translate(-783 -208) translate(783 208)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDown);
export default __webpack_public_path__ + "static/media/ico-down.241b1b5139dd54b5fce0d9c49d7db588.svg";
export { ForwardRef as ReactComponent };